/*
*
* @module : Translation
* @file : Translation.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of Translation
*
* Created on : 15-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 24-Oct-2019
*/
class Translation
{
	getText(text)
	{
		var textData = {
			'home_v1':'«Wissen schafft Nahrung»',
			'home_v5':'Willkommen zum grossen Öko-Quiz von Biovision',
			'home_v2':'Sind Sie eine Ostafrika-Kennerin? Ein Nachhaltigkeitsexperte? Eine Biovision-Insiderin? Finden Sie es heraus! Im grossen Öko-Quiz.',
			'home_v3':'Jede Teilnehmerin und jeder Teilnehmer erhält ein Geschenk von Biovision als Dankeschön.',
			'home_v4':'Quiz starten',
			'topics_v1':'Wählen Sie ein Themengebiet',
			'questions_v1':'Agrarökologie',
			'questions_v2':'weiter',
			'questions_v3':'zurück',
                  'questions_v4':'Quiz auswerten und Punktzahl erfahren',
			'result_v1':'Herzliche Gratulation',
			'result_v2':'Sie haben ',
			'result_v3':' ',
			'result_v4':'von total 25 Punkten erreicht!',
			'result_v11': 'Die Auflösung des Quiz mit korrekten Antworten erhalten Sie in einigen Tagen per E-Mail.',
			'result_v5':'Für Ihre freiwillige Weiterbildung bedanken wir uns herzlich, denn:',
			'result_v10':'Wissen schafft Nahrung!',
			'result_v6':'Wir möchten Sie für Ihr Wissen belohnen. ',
			'result_v7':'Bitte wählen Sie nun Ihr Geschenk aus:',
			'result_v8':'weiter',
			'result_v9':'%challenger_name% hat im Vergleich einen Score von %challenger_score% Punkten erreicht.',
			'result_v12': 'PS: Ihr Geschenk wird Ihnen in circa einer Woche zugestellt.',
			'result_v13': 'Aus Umweltschutzgründen versenden wir pro Person maximal ein Paket.',
                  'user_details_v1':'Ihr Geschenk​​',
                  'user_details_v2':'Sie haben folgendes Geschenk ausgewählt',
                  'user_details_v3':'Vorname',
                  'user_details_v4':'Nachname',
                  'user_details_v5':'Adresszusatz',
                  'user_details_v6':'Adresse',
                  'user_details_v7':'PLZ/Ort',
                  'user_details_v8':'Land',
                  'user_details_v9':'E-Mail',
                  'user_details_v10':'Angaben absenden',
                  'user_details_v11':'Datenschutzhinweise',
                  'user_details_v12':'(Versand ausschliesslich innerhalb der Schweiz und Liechtenstein.)',
                  'user_details_v13':'Damit wir Ihnen Ihr Geschenk zustellen können und Ihnen die Quiz-Lösungen mitteilen können, bitten wir Sie um folgende Angaben:',
                  'user_details_v14':'Kommentar',
                  'user_details_v15':'z.B. T-Shirt Geschenk: Grösse',
                  'thankyou_v1':'Vielen Dank!',
                  'thankyou_v2':'Die Quiz-Auflösung erhalten Sie in einer Woche per E-Mail.',
                  'thankyou_v3':'Fordern Sie Freundinnen oder Kollegen auf, am Quiz teilzunehmen – und sich mit Ihnen zu messen. ',
                  'thankyou_v4':'Anschliessend erfahren Sie, wer gewonnen hat.',
                  'thankyou_v5':'Ihr Name',
                  'thankyou_v6':'Ihr E-Mail',
                  'thankyou_v7':'Wen nominieren Sie, um es mit Ihnen aufzunehmen?',
                  'thankyou_v8':'Name',
                  'thankyou_v9':'E-Mail',
                  'thankyou_v10':'Weitere Personen herausfordern...',
                  'thankyou_v11':'Überspringen',
                  'thankyou_v12':'Jetzt herausfordern',
                  'thankyou_v13':'Datenschutzhinweise',
                  'donate_v1':'Danke fürs Mitmachen',
                  'donate_v2':'Biovision vermittelt ökologisches Wissen in der Schweiz und in Ostafrika.',
                  'donate_v3':'Möchten Sie unsere Projektarbeit mit einer Spende unterstützen?',
                  'donate_v4':'Spende tätigen',
                  'donate_v5':'Nein, Quiz hiermit beenden',
                  'quiz_end_v1':'Herzlichen Dank,',
                  'quiz_end_v2':'dass Sie mitgemacht haben.',
                  'quiz_end_v3':'Mehr Informationen zu unserer Arbeit erhalten Sie',
                  'quiz_end_v4':'hier',
                  'challenge_v1':'«Wissen schafft Nahrung» Willkommen zum Biovision-Quiz',
                  'challenge_v2':'hat Sie zum Biovision-Öko-Quiz herausgefordert.',
                  'challenge_v3':'Sie werden ihre/seine Punktzahl am Ende des Quiz erfahren.',
                  'challenge_v4':'Sind Sie eine Ostafrika-Kennerin? Ein Nachhaltigkeitsexperte? Eine Biovision-Insiderin? Finden Sie es heraus! Im grossen Öko-Quiz.',
                  'challenge_v5':'Jede Teilnehmerin und jeder Teilnehmer erhält ein Geschenk von Biovision als Dankeschön.',
                  'challenge_v6':'Quiz starten',
                  'challenge_v7':'Es tut uns leid',
                  'challenge_v8':'Dieser Link ist leider abgelaufen.',
                  'challenge_v9':'Quiz erneut spielen',
                  'play_again_v1':'Wollen Sie nochmal spielen?',
                  'play_again_v2':'Ja, neues Thema wählen',
                  'play_again_v3':'Nein danke',
                  'play_again_v4':'Sie haben soeben unser Öko-Quiz abgeschlossen. Danke fürs Mitmachen! Möchten Sie Ihr Wissen noch in einem anderen Themengebiet testen?',

		}

		return textData[text];
	}
}

export default Translation;